





























import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { BaseGlass } from "@share/common/form/form-controls/base/glass/base-glass";
import { StubInputBase } from "@share/common/form/form-controls/stub/stub-input-base";
import TzDropdown from "@share/common/tz-selector/tz-dropdown.vue";
import { DropDownItem } from "@share/common/drop-down/types";

@Component({ components: { TzDropdown } })

export default class SingleSelectS01 extends Mixins(BaseGlass, StubInputBase) {

    @Prop({ required: true }) list: DropDownItem[];
    @Prop({ default: true }) useTransition: boolean;

    showDropdown = false;
    title = "";

    mounted() {
        this.setSelected();
    }

    @Watch('value')
    setSelected() {
        const selected = this.list.find((item) => item.id === this.value);
        this.title = selected?.title.trim() || "";
    }

    select(item: DropDownItem) {
        this.showDropdown = false;
        this.title = item.title.trim();
        this.$emit('input', item.id);
    }

    toggle () {
        this.showDropdown = !this.showDropdown;

        !this.focused && (this.focused = true);
    }
}

